"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("@mui/material/styles");
/**
 * @ignore - internal component.
 */
var HiBriefcaseRescue = (0, _pure.default)(function (props) {
  var theme = (0, _styles.useTheme)();
  var _props$color = props.color,
    color = _props$color === void 0 ? props.color || theme.palette.neutral.main : _props$color,
    style = props.style,
    other = (0, _objectWithoutProperties2.default)(props, ["color", "style"]);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    style: (0, _objectSpread2.default)({}, style, {
      fontSize: props.size || 24
    })
  }, other), /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 540 540"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M540 108H378V27a27 27 0 0 0-27-27H189a27 27 0 0 0-27 27v81H54a54.06 54.06 0 0 0-54 54v270a54.06 54.06 0 0 0 54 54h432a54.06 54.06 0 0 0 54-54V162a54.06 54.06 0 0 0-54-54zM216 54h108v54H216zm162 270h-81v81h-54v-81h-81v-54h81v-81h54v81h81z",
    fill: color
  })));
});
HiBriefcaseRescue.muiName = 'SvgIcon';
var _default = exports.default = HiBriefcaseRescue;